import { invalidateOwner, Magnitude } from 'gear';
import { Xml } from '../util';
import { Process } from './process';

// Split
//===============================================================================================

const Split = Process.Split = Process.extend({ typeName: 'SplitProcess',
  type: 'Split',
  Properties: {
    overlap  : { type: 'magnitude'  , def: new Magnitude(0,'mm')   , onChange: invalidateOwner, dropDef:true },
    pos      : { type: 'magnitude'  , def: new Magnitude(0.5,'mm') , onChange: invalidateOwner, dropDef:true },
    turn     : { type: 'number'     , def: 0                       , onChange: invalidateOwner, dropDef:true },
    gap      : { type: 'magnitude'  , def: new Magnitude(10,'mm')  , onChange: invalidateOwner, dropDef:true }
  }
});
Xml.addFromBuild(Split);



/** WEBPACK FOOTER **
 ** ./src/cdl/process/clip.js
 **/